import script from "./AppLoader.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppLoader.vue?vue&type=script&lang=ts&setup=true"

import "./AppLoader.vue?vue&type=style&index=0&id=7a398d3c&lang=scss"

const __exports__ = script;

export default __exports__